"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTimezoneListDto = instanceOfTimezoneListDto;
exports.TimezoneListDtoFromJSON = TimezoneListDtoFromJSON;
exports.TimezoneListDtoFromJSONTyped = TimezoneListDtoFromJSONTyped;
exports.TimezoneListDtoToJSON = TimezoneListDtoToJSON;
exports.TimezoneListDtoToJSONTyped = TimezoneListDtoToJSONTyped;
var TimezoneItemDto_1 = require("./TimezoneItemDto");
/**
 * Check if a given object implements the TimezoneListDto interface.
 */
function instanceOfTimezoneListDto(value) {
    if (!('selectedId' in value) || value['selectedId'] === undefined)
        return false;
    if (!('defaultId' in value) || value['defaultId'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
function TimezoneListDtoFromJSON(json) {
    return TimezoneListDtoFromJSONTyped(json, false);
}
function TimezoneListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectedId': json['selectedId'],
        'defaultId': json['defaultId'],
        'items': (json['items'].map(TimezoneItemDto_1.TimezoneItemDtoFromJSON)),
    };
}
function TimezoneListDtoToJSON(json) {
    return TimezoneListDtoToJSONTyped(json, false);
}
function TimezoneListDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'selectedId': value['selectedId'],
        'defaultId': value['defaultId'],
        'items': (value['items'].map(TimezoneItemDto_1.TimezoneItemDtoToJSON)),
    };
}
